import { createRootRoute, Outlet } from '@tanstack/react-router';
import { HeadContent } from '@tanstack/react-router';

import CreatePaymentFailed from '@/components/create-payment-failed';
import { IS_LANG_EN } from '@/constants/general';

interface NotFoundError extends Error {
  status: number;
  statusText: string;
  url: string;
  pathname: string;
  timestamp: string;
}

export const Route = createRootRoute({
  head: () => ({
    meta: [
      {
        title: IS_LANG_EN ? 'Cashier - Recharge' : '收银台-充值',
      },
    ],
  }),
  component: () => (
    <>
      <HeadContent />
      <Outlet />
    </>
  ),
  notFoundComponent: () => {
    const notFoundError: NotFoundError = Object.assign(
      new Error('Page not found - The requested resource could not be found'),
      {
        name: 'NotFoundError',
        status: 404,
        statusText: 'Not Found',
        url: window.location.href,
        pathname: window.location.pathname,
        timestamp: new Date().toISOString(),
      }
    );

    return <CreatePaymentFailed error={notFoundError} />;
  },
  errorComponent: ({ error }) => {
    return <CreatePaymentFailed error={error} />;
  },
});
